import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ZoomContextType {
    zoom: number;
    setZoom: (zoom: number) => void;
}

const ZoomContext = createContext<ZoomContextType | undefined>(undefined);

export function ZoomProvider({ children }: { children: ReactNode }) {
    const [zoom, setZoom] = useState<number>(100);

    return (
        <ZoomContext.Provider value={{ zoom, setZoom }}>
            {children}
        </ZoomContext.Provider>
    );
}

export function useZoom(): [number, (zoom: number) => void] {
    const context = useContext(ZoomContext);
    if (!context) {
        throw new Error('useZoom must be used within a ZoomProvider');
    }
    return [context.zoom, context.setZoom];
}
